import React from 'react';

export const LeftCard: React.FC<{
  backgroundImage: string;
  logo?: React.ReactNode;
  title?: string;
  subtitle?: string;
}> = ({ backgroundImage, logo, title, subtitle }) => {
  return (
    <>
      <div
        className="relative hidden h-full flex-col p-10 text-white dark:border-r lg:flex filter brightness-75 bg-center"
        style={{
          background: `url(${backgroundImage})`,
          backgroundSize: 'cover',
        }}
      ></div>
      <div className="fixed hidden lg:flex lg:flex-col lg:gap-6 lg:max-w-[40vw] top-20 left-16">
        <div>{logo}</div>
        {title && (
          <div className="text-background text-5xl font-semibold">{title}</div>
        )}
        {subtitle && (
          <div className="text-background text-base font-medium mt-4">
            {subtitle}
          </div>
        )}
      </div>
    </>
  );
};
